import {
  getZipFromGeocoderResults,
  GeocodeResult,
} from './getZipFromGeocoderResults'

/** Represents the response returned by `getZipFromLatLon`. */
export interface ZipResponse {
  zip?: string
  lat: number
  lon: number
  error?: boolean
  response?: {
    message: string
  }
}

/**
 * Given a latitude and longitude, this function will use Google Maps utilities
 * to return the zip code.
 *
 * @param {number} lat - The latitude to use
 * @param {number} lon - The longitude to use
 * @returns {Promise<ZipResponse>} - A promise resolving to a zip response
 */
export const getZipFromLatLon = async (
  lat: number,
  lon: number,
): Promise<ZipResponse> => {
  if (!(window as any).google?.maps) {
    return {
      error: true,
      response: {
        message: 'Google map utilities are not available.',
      },
      lat,
      lon,
    }
  }

  const { LatLng } = await (window as any).google.maps.importLibrary('core')
  const { Geocoder } = await (window as any).google.maps.importLibrary(
    'geocoding',
  )

  const latLng = new LatLng(lat, lon)
  const geocoder = new Geocoder()

  return new Promise(resolve => {
    return geocoder.geocode(
      { latLng },
      (results: GeocodeResult[], status: string) => {
        if (status !== 'OK') {
          return resolve({
            error: true,
            response: {
              message: 'Could not get geocode information.',
            },
            lat,
            lon,
          })
        }

        let zip = getZipFromGeocoderResults(results, 0)
        if (!zip) {
          zip = getZipFromGeocoderResults(results, 1)
        }
        if (zip === '45145') {
          zip = '45201'
        }
        resolve({ zip, lat, lon })
      },
    )
  })
}
